export function normalize(s: string): string {
  s = toHalfWidth(s);
  s = kanaToHira(s);
  s = normalizeStar(s);
  s = s.toLowerCase();
  return s;
}

// https://qiita.com/spm84/items/4ea8c53ac3aafcd4d66c
// 全角 -> 半角 (英数字)
function toHalfWidth(str: string) {
  // 全角英数字を半角に変換
  str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
  return str;
}

// カタカナ->ひらがな
function kanaToHira(str: string) {
  return str.replace(/[\u30a1-\u30f6]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0x60);
  });
}

// ☆ -> ★
function normalizeStar(str: string) {
  return str.replace(/☆/g, "★");
}
